import {Injectable} from '@angular/core';
import {FormDefinitionFormConverter} from '../../../../../form/definition/form/api/entity/converter/formDefinitionForm.converter';
import {ExamenDefinitionModel} from '../examenDefinition.model';
import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {ExamenDefinitionSummaryConverter} from './examenDefinitionSummary.converter';

@Injectable({
    providedIn: 'root'
})
export class ExamenDefinitionConverter extends HttpModelConverter<ExamenDefinitionModel> {

    constructor(private examenDefinitionSummaryConverter: ExamenDefinitionSummaryConverter,
                private formDefinitionFormConverter: FormDefinitionFormConverter) {
        super();
    }

    protected createInstance(): ExamenDefinitionModel {
        return new ExamenDefinitionModel();
    }

    protected enrichObject(result: ExamenDefinitionModel, src: ExamenDefinitionModel) {
        result.summary = this.examenDefinitionSummaryConverter.convert(src.summary);
        result.formDefinition = this.formDefinitionFormConverter.convert(src.formDefinition);
    }

}
